import { useEffect, useState } from 'react';
import { useGate, useUnit } from 'effector-react';
import { Tab } from '@mui/material';
import { $timezone } from '@features/common';
import { getCookie } from '@tools/cookie';
import { Tabs } from '@ui/index';
import { ChildBase, SDUI } from '@unicorn/sdui';
import { $currentTab, changeTab, tabs, closeDetail } from '../../../models';
import { $openedId } from '../../../models/detail-sdui-opened-id/model';
import {
  $customFieldsSduiJson,
  $sduiTicketData,
  CustomFieldsGate,
  NEW_OPENED_ID,
} from '../../../models/detail-sdui/model';
import { $addRelation } from '../../../models/related-tickets';
import { DetailSdui } from '../../detail-sdui';
import { DetailInvocesSdui } from '../../detail-sdui-invoces';
import { HeaderRelatedTickets, HeaderSdui } from '../../detail-sdui/components/header';
import { RetaledTicketsTab } from '../../retaled-tickets-tab';
import { RetaledAvailable } from '../../retaled-tickets-tab/add-related-available/ux';
import { SnackAlerts as RelatedSnackAlerts } from '../../retaled-tickets-tab/snack-alerts';
import { TicketWorks } from '../../ticket-works';
import * as Styled from '../styled';

const ticketsSdui = new SDUI('tickets');

export const RightSduiDetail = () => {
  const [sduiData, setSduiData] = useState([] as ChildBase[]);
  const [currentTab, openedId, customFieldsSduiJson, sduiTicketData, addRelation] =
    useUnit([
      $currentTab,
      $openedId,
      $customFieldsSduiJson,
      $sduiTicketData,
      $addRelation,
    ]);

  const baseSduiConfig = {
    log: false,
    apiTimeout: 30000,
    custom: {
      app: 'crm',
      token: getCookie('bms_token'),
      timezone: ($timezone as any).stateRef.current,
    },
  };

  const onChange = (_: unknown, tab: string) => changeTab(tab);

  useGate(CustomFieldsGate, { openedId });

  useEffect(() => {
    if (!openedId) return;

    ticketsSdui.setSduiConfig({
      ...baseSduiConfig,
      setSduiData,
    });
  }, []);

  useEffect(() => {
    if (!openedId) return;
    if (customFieldsSduiJson === null) return;

    ticketsSdui.setSduiSource({ source: customFieldsSduiJson });
  }, [customFieldsSduiJson]);

  const hasAccountsTab = !!sduiTicketData.is_paid && openedId !== NEW_OPENED_ID;
  const isIncident = sduiTicketData.class === 'incident';

  const isNew = openedId === NEW_OPENED_ID;

  if (addRelation)
    return (
      <Styled.RightDetailContainer elevation={0}>
        <HeaderRelatedTickets />

        <RetaledAvailable />
      </Styled.RightDetailContainer>
    );

  return (
    <Styled.RightDetailContainer elevation={0}>
      <HeaderSdui isIncident={isIncident} />

      <Tabs
        options={tabs({ isNew, hasAccountsTab, isIncident })}
        currentTab={currentTab}
        onChange={onChange}
        isNew={isNew}
        tabEl={<Tab />}
        scrollButtons={false}
      />

      {currentTab === 'info' && (
        <DetailSdui
          openedId={openedId}
          sduiData={sduiData}
          ticketsSdui={ticketsSdui}
          onCreateCancel={() => closeDetail()}
        />
      )}

      {currentTab === 'invoces' && <DetailInvocesSdui openedId={openedId} />}

      <>
        <RelatedSnackAlerts />
        {currentTab === 'related-tickets' && <RetaledTicketsTab />}
      </>

      {currentTab === 'works' && <TicketWorks />}
    </Styled.RightDetailContainer>
  );
};
